import React, { Fragment } from 'react';

import {
  fatalError,
  resetBrokenFlag,
  loadingStarted,
  loadingFinished,
  changesMade,
  changesSaved,
  savedTimeUpdated,
  loadedInitialState
} from 'RLX/State/Ui/UiCreators';

import RLXStore from 'RLX/State/Store';
import stringify from 'fast-safe-stringify'
export * from 'RLX/State/Ui/Sidebar/SidebarActions';

export function handleError (error, ...loggables) {
  console.error(error, ...loggables);
  const { message } = error;
  const display = (
    <Fragment>
      <h2>{error.message}</h2>
      <pre><code>{stringify(error, null, '  ')}</code></pre>
    </Fragment>
  );
  RLXStore.dispatch(fatalError(display));
};

export function dismissError () {
  RLXStore.dispatch(resetBrokenFlag());
};

export function updateSavedTime () {
  RLXStore.dispatch(savedTimeUpdated());
}

export function startLoading () {
  RLXStore.dispatch(loadingStarted());
};

export function declareUnsavedChanges () {
  RLXStore.dispatch(changesMade());
};
export function declareSavedChanges () {
  RLXStore.dispatch(changesSaved());
};

export function finishLoading () {
  RLXStore.dispatch(loadingFinished());
};

export function initialStateLoaded () {
  RLXStore.dispatch(loadedInitialState());
};



// WEBPACK FOOTER //
// ./client/RLX/State/Ui/UiActions.js